import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { clearRuleEditor } from "../../../redux/features/ruleEditor/ruleEditorSlice";

/**
 * Page-level logic for RuleEditor: reads the rule id from the URL and
 * resets the page-local slice on unmount (cleanup pattern from the
 * manualSearch/activityLog reference pages). Server data fetching lives
 * in QueryBuilder via useRuleQuery — not duplicated here.
 */
export function useRuleEditor() {
  const { id: ruleId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearRuleEditor());
    };
  }, [dispatch]);

  return { ruleId };
}
